import type { ExtendedAxiosRequestConfig } from '@/lib/api/types'

/**
 * Optional enrichment for address ra_ids / import prompts.
 * Backend RoleAuth on GET /api/resident_application/:id allows only
 * underwriter/CS/refund_approval/renter — Liberty Default (and several other
 * liberty roles) get "Access Denied". Angular does not call this on detail open;
 * callers must treat failure as non-fatal and must not bounce to dashboard.
 */
export const RESIDENT_APPLICATION_ENRICHMENT_CONFIG = {
  skipAccessDeniedRedirect: true,
} as ExtendedAxiosRequestConfig
